import { modules } from "../../components/modules";
import { SECTIONS } from "../config";
import { FLOW_MESSAGES } from "../../components/shared/components/flowMessages/components";
import { MILESTONES } from "../../components/shared/sharedKernel/EventCatcher/config";
import { EVENT_TYPES } from "nemuru-components";
import { LenderApprovalStatus } from "@nemuru-eng/js-api-client";

export const flowClientSideKycSignatureMultiLender = {
  name: "ClientSideKYCSignatureMultiLender",
  modules: [
    {
      id: modules.DOCUMENTATION.id,
      onKO: null,
      section: {
        name: SECTIONS.DOCUMENTATION,
        progressPercentage: "50%",
      },
      onOK: {
        showOKMessage: {
          id: FLOW_MESSAGES.DOCUMENTATION_UPLOADED.id,
          fadeIn: true,
        },
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          (processState.loan.loan_application_selected &&
            processState.loan.loan_application_selected?.lender_fields
              .loan_application_status.lender_approval_status !==
              LenderApprovalStatus.YES) ||
          !processState.documentationRequired.are_required_files_uploaded,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.APPLICATION_INFO.id,
      props: {
        disableDocumentation: true,
      },
      onKO: null,
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan.loan_application_selected &&
          processState.loan.loan_application_selected?.lender_fields
            .loan_application_status.lender_approval_status !==
            LenderApprovalStatus.YES &&
          processState.documentationRequired.are_documents_confirmed,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK.id,
      },
    },
    {
      id: modules.KYC_AUTOMATIC_WITH_NIE_EU.id,
      props: {
        disableAdditionalData: true,
        disableKycManual: true,
      },
      onKO: {
        sendEvents: [
          {
            name: MILESTONES.KYC_ELECTRONIC_ID_ERROR,
            type: EVENT_TYPES.error,
          },
        ],
      },
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "50%",
      },
      onOK: {
        showOKMessage: {
          id: FLOW_MESSAGES.SECTION_IDENTIFICATION_END.id,
          fadeIn: true,
        },
        sendEvents: [
          {
            name: MILESTONES.KYC_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.onboarding_details[0].kyc_id &&
          processState.loan.loan_application_selected &&
          processState.loan.loan_application_selected?.lender_fields
            .loan_application_status.lender_approval_status ===
            LenderApprovalStatus.YES &&
          processState.documentationRequired.are_documents_confirmed,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.APPLICATION_INFO.id,
      props: {
        disableDocumentation: true,
      },
      onKO: null,
      section: {
        name: SECTIONS.SIGNATURE,
        progressPercentage: "0%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.loan_application_ids &&
          processState.loan?.loan_application_ids.length !== 0,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK.id,
      },
    },
    {
      id: modules.OPTINS_AND_SIGNATURE.id,
      onKO: null,
      section: {
        name: SECTIONS.SIGNATURE,
        progressPercentage: "50%",
      },
    },
    {
      id: modules.APPLICATION_INFO.id,
      props: {
        disableDocumentation: true,
      },
      onKO: null,
      section: {
        name: null,
      },
    },
  ],
};
